import Vue from 'vue';
import App from '@/App';
import errorTracker from '@/utility/errorTracker';

Vue.config.productionTip = false;

errorTracker.maybeInitErrorTracker();

new Vue({
  render: (h) => h(App),
}).$mount('#app');
